import { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import S, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { useIntersecting } from "../../../../../hooks/useIntersecting";
import { SectionProps } from "../../../shared/types";
import {
  colorV2,
  cssTemplate,
  media,
  mobileContainerGap,
  pcContainerGap,
  typographyV2,
} from "../../../../../constants/styles";
import { Wrapper } from "../../../shared/styled";
import Responsable from "../../../../Responsable";

import { ReactComponent as ArrowRight } from "../../../../../svgs/Arrow-L-Right.svg";
import { ReactComponent as PrimaryArrowRight } from "../../../../../svgs/arrow-right.svg";
import { Link } from "react-router-dom";

interface Props extends SectionProps { }

const partners = [
  {
    id: "tire-pick",
    name: "Tirepick",
    imageUrl: "/image/home/square-tirepick.png",
    title: "타이어픽",
    description: "타이어 커머스 플랫폼",
    destination: "https://tirepick.com",
  },
  {
    id: "ever-on",
    name: "Everon",
    imageUrl: "/image/home/square-everon.png",
    title: "에버온",
    description: "전기차 충전 인프라 서비스",
    destination: "https://everon.com",
  },
  {
    id: "sm-town",
    name: "SM",
    imageUrl: "/image/home/square-sm.png",
    title: "SM",
    description: "엔터테인먼트 디지털 전환",
    destination: "https://sm.com",
  },
  {
    id: "pluspot",
    name: "Pluspot",
    imageUrl: "/image/home/square-pluspot.png",
    title: "플러스팟",
    description: "공간 공유 플랫폼",
    destination: "https://pluspot.com",
  },
];

const ScrollOverlayProjects: React.FC<Props> = () => {
  const swiperRef = useRef<S | null>(null);
  const { ref, isIntersecting } = useIntersecting();
  const [interacted, setInteracted] = useState<boolean>(false);
  const [_, setActiveIndex] = useState(0); // 추가: 현재 활성화된 슬라이드 인덱스

  const slideNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };
  const slidePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  useEffect(() => {
    if (isIntersecting) setInteracted(true);
  }, [isIntersecting]);

  return (
    <Container ref={ref} theme={{ isIntersecting: interacted }}>
      <TextSectionWrapper>
        <TextSection>
          <h3>Our Project</h3>
          <Responsable
            widthFull
            pc={
              <ContentWrapper>
                <h2>
                  슬로그업은 도전과 창조로 IT가 필요한 곳에
                  <br />
                  IT가 있게 하는 테크 프로바이더 팀 입니다
                </h2>
              </ContentWrapper>
            }
            tablet={
              <ContentWrapper>
                <h2>
                  슬로그업은 도전과 창조로 <br />
                  IT가 필요한 곳에 IT가 있게 하는 <br />
                  테크 프로바이더 팀 입니다
                </h2>
              </ContentWrapper>
            }
            mobile={
              <ContentWrapper>
                <h2>
                  슬로그업은 도전과 창조로
                  <br />
                  IT가 필요한 곳에
                  <br />
                  IT가 있게 하는
                  <br />
                  테크 프로바이더 팀 입니다
                </h2>
              </ContentWrapper>
            }
          />
        </TextSection>
      </TextSectionWrapper>

      <Swiper
        style={{
          position: "relative",
        }}
        modules={[Autoplay]}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={(swiper) => {
          setActiveIndex(swiper.realIndex);
        }}
        slidesPerView={1.5}
        slideToClickedSlide
        autoplay={{
          delay: 3000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        spaceBetween={24}
        loop
        centeredSlides={true}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          1024: {
            // PC
            slidesPerView: 2.5,
          },
          1440: {
            // 큰 PC
            slidesPerView: 2.7,
          },
        }}
      >
        {partners.map((partner) => (
          <StyledSwiperSlide key={partner.id}>
            <Link to={`/project/${partner.id}`}>
              <figure onClick={() => console.log(123)}>
                <img src={partner.imageUrl} alt={partner.name} />
                <HoverContent>
                  <h4>{partner.title}</h4>
                  <p>{partner.description}</p>
                  <PrimaryArrowRight />
                </HoverContent>
              </figure>
            </Link>
          </StyledSwiperSlide>
        ))}

        <ArrowWrapper isLeft onClick={slidePrev}>
          <PrimaryArrowRight />
        </ArrowWrapper>

        <ArrowWrapper onClick={slideNext}>
          <PrimaryArrowRight />
        </ArrowWrapper>
      </Swiper>

      <Link to="/project">
        <TextButton>
          프로젝트 더보기
          <ArrowRight />
        </TextButton>
      </Link>
    </Container>
  );
};
export default ScrollOverlayProjects;

const Container = styled.div`
  ${(props) => cssTemplate.fadeInOut(props)}
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 160px 0;
  gap: 100px;
  width: 100%;

  .swiper {
    width: 100%;
    max-height: 616px;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 720px;
  }

  .swiper-slide-prev,
  .swiper-slide-next {
    transition: opacity 0.5s ease, transform 0.5s ease;
    opacity: 0.6;
    transform: scale(0.9);
  }

  ${media.TABLET} {
    padding: 140px 0;
  }

  ${media.MOBILE} {
    gap: ${mobileContainerGap};
    padding: 80px 0;
  }
`;

const SectionWrapper = styled(Wrapper)`
  align-items: flex-start;
  justify-content: flex-start;
  ${media.TABLET} {
    padding-right: 0px;
  }
`;
const TextSectionWrapper = styled(SectionWrapper)`
  width: 100%;
  gap: ${pcContainerGap};

  ${media.TABLET} {
    padding: 0px;
  }
`;
const TextSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;

  h2 {
    ${typographyV2.HEADING_1_B}
    color: ${colorV2.GRAY_01};
  }

  h3 {
    ${typographyV2.BODY_2_M};
    color: ${colorV2.GRAY_01};
  }

  ${media.MOBILE} {
    max-width: 100%;
    padding: 0 24px;
    h2 {
      ${typographyV2.HEADING_3_B}
    }

    h3 {
      ${typographyV2.BODY_4_M};
    }
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
`;

const ArrowWrapper = styled.div<{ isLeft?: boolean }>`
  position: absolute;
  top: 50%;
  z-index: 10;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${colorV2.GRAY_01};
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ isLeft }) =>
    isLeft
      ? css`
          transform: rotate(180deg) translateY(50%);
          left: 120px;
        `
      : css`
          transform: rotate(0deg) translateY(-50%);
          right: 120px;
        `}
  cursor: pointer;

  svg {
    width: 52px;
    height: 52px;
  }

  ${media.TABLET} {
    width: 60px;
    height: 60px;
    ${({ isLeft }) =>
    isLeft
      ? css`
            left: 48px;
          `
      : css`
            right: 48px;
          `}

    svg {
      width: 32px;
      height: 32px;
    }
  }

  ${media.MOBILE} {
    width: 32px;
    height: 32px;
    padding: 8px;

    ${({ isLeft }) =>
    isLeft
      ? css`
            left: 24px;
          `
      : css`
            right: 24px;
          `}
  }
`;

const HoverContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;

  h4 {
    ${typographyV2.HEADING_1_B}
    font-size: 60px;
    line-height: 1.4;
    color: white;
  }

  p {
    ${typographyV2.BODY_2_M}
    color: white;
    text-align: center;
    padding-bottom: 40px;
  }

  ${media.MOBILE} {
    display: none;
  }
`;

const StyledSwiperSlide = styled(SwiperSlide)`
  figure {
    position: relative;
    width: auto;
    max-height: 616px;
    overflow: hidden;
    cursor: pointer;
    border-radius: 42px;

    img {
      width: 100%;
      object-fit: contain;
      transition: transform 0.3s ease;
    }

    &:hover {
      img {
        transform: scale(1.05);
      }

      ${HoverContent} {
        z-index: 1;
        opacity: 1;
      }
    }
  }

  &.swiper-slide-next,
  &.swiper-slide-prev {
    figure {
      &:hover {
        img {
          transform: scale(1);
        }

        ${HoverContent} {
          z-index: 0;
          opacity: 0;
        }
      }
    }
  }

  &.swiper-slide-active {
    z-index: 1;
  }

  ${media.MOBILE} {
    figure {
      border-radius: 16px;
    }
  }
`;

const TextButton = styled.button`
  all: unset;
  ${typographyV2.HEADING_2_B};
  color: ${colorV2.GRAY_01};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: gap 0.2s ease-out;

  &:hover {
    gap: 32px;
  }

  ${media.MOBILE} {
    ${typographyV2.HEADING_7_B};

    svg {
      width: 24px;
      height: 24px;
    }

    &:hover {
      gap: 24px;
    }
  }
`;
